"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  // 公共
  common: {
    organizationConfiguration: '组织与流程配置',
    onlineUserInfo: '在线人员信息',
    serialNumber: '序号',
    operation: '操作',
    remark: '备注',
    group: '集团',
    total: '总计',
    btn: {
      add: '新 增',
      del: '删 除',
      fresh: '刷 新',
      confirm: '确 定',
      cancel: '取 消',
      changeUnit: '更改上级单位',
      export: '导 出',
      import: '导 入',
      download: '模板下载',
      save: '保 存',
      checkAccount: '查看账号',
      replaceFleet: '更换船队',
      remove: '移 除',
      addShip: '添加船舶',
      specifyAccount: '指定账号',
      create: '生 成',
      check: '查 询',
      reset: '重 置',
      cancelLogout: '取消注销',
      logout: '注销',
      ripInfo: '生成内部供应商信息',
      close: '关闭',
      migration: '迁移',
      copyOperationFrom: '复制操作权限从',
      attachmentUpload: '附件上传',
      downloadAttachments: '下载附件',
      deleteAttachment: '删除附件',
      preview: '预览',
      insertRow: '插入一行',
      portChange: '港口变更',
      acquirePortSpace: '获取港间距',
      estimate: '测算',
      importPallet: '导入新货盘',
      print: '打印',
      copyEstimate: '复制测算',
      viewFormula: '查看公式',
      audit: '审核',
      estimateTemplate: '形成测算模板',
      paymentApplication: '付款申请',
      approvalProcess: '审批流程',
      refresh: '刷新'
    },
    placeholder: {
      select: '请选择组织...',
      showCancel: '显示注销',
      search: '快速搜索',
      enterCode: '请输入待办代码',
      pleaseSelect: '请选择',
      enterContent: '请输入内容',
      takeEffect: '生效',
      loseEfficacy: '失效',
      pleaseEnter: '请输入',
      optionDate: '选择日期'
    },
    message: {
      hintTitle: '是否确认删除该记录',
      hint: '提示',
      successfullyDelete: '删除成功',
      failDelete: '删除失败',
      changeSuccess: '更改成功',
      saveSuccessfully: '保存成功',
      newSuccess: '新增成功',
      updateSuccessfully: '更新成功',
      message1: '请选择要删除的组织',
      message2: '请选择要更改上级单位的组织',
      message3: '请选择要更改的上级组织',
      message4: '船队名称不可为空',
      message5: '请选择要删除的船队',
      message6: '请先保存船队信息',
      message7: '请选择船舶',
      message8: '已存在，其余保存成功',
      message9: '请选择需要移除的船舶',
      message10: '请选择要更换船队的船舶',
      message11: '更换船队成功',
      message12: '请至少勾选一条船舶数据',
      message13: '请选择账号',
      message14: '指定账号成功',
      message15: '请选择需要更改时间的记录',
      message16: '请选择开始时间',
      message17: '请选择新船队',
      message18: '请选择勾选至少一条船舶',
      message19: '请至少生成一条记录',
      message20: '请选择需要删除的记录',
      message21: '更改时间成功',
      message22: '操作成功',
      message23: '操作失败',
      message24: '是否删除该配置, 是否继续?',
      message25: '结束时间不能小于开始时间',
      message26: '角色不可为空',
      message27: '取消注销成功',
      message28: '确定生成内部供应商信息？',
      message29: '请选择要删除的账号',
      message30: '请选择要迁移组织的账号',
      message31: '请选择迁移组织',
      message32: '请选择要插入的行',
      message33: '请先添加对应的空放信息',
      message34: '请选择需要合并的行',
      message35: '请勾选要删除的数据',
      message36: '请选择经纪人要删除的组织',
      message37: '请选择超出货量要删除的数据',
      message38: '请选择货量信息要删除的数据',
      message39: '只能勾选一条数据',
      alreadyExist: '已存在',
      yes: '是',
      no: '否',
      generateSuccess: '生成成功',
      cancellationSuccess: '注销成功',
      continue: '继续',
      successfulMigration: '迁移成功'
    },
    examine: {
      rules1: '请输入组织代码',
      rules2: '长度在 1 到 50 个字符',
      rules3: '请输入组织名称',
      rules4: '长度在 1 到 200 个字符',
      rules5: '请选择国家/地区',
      rules6: '请选择组织类型'
    }
  },
  // 代办配置管理
  workConfig: {
    backlogConfigurationManagement: '待办配置管理',
    taskCode: '待办代码',
    taskSummaryType: '待办汇总分类',
    taskName: '待办名称',
    taskName2: '待办名称',
    taskName3: '公司名称',
    taskType: '待办分类',
    activeDate: '生效时间',
    invalidDate: '失效时间',
    taskNameCn: '自定义待办(中文)',
    taskNameEn: '自定义待办(英文)',
    validFlag: '状态',
    newBacklogConfiguration: '新增待办配置',
    backlogConfigurationDetails: '待办配置明细',
    examineApprove: '审批',
    name: '名称',
    systematicName: '分类名称'
  },
  // 消息提醒配置
  msgRemindConfig: {
    messageConfiguration: '消息提醒配置',
    company: '公司',
    dept: '部门',
    role: '角色',
    user: '用户',
    postRoleFlag: '适用于岗位角色',
    applyType: '适用范围',
    applyObject: '适用对象',
    postRoleFlag1: '适用岗位角色',
    customFlag: '是否自定义配置',
    meaasgeMode: '消息模块',
    messageType: '消息类型',
    subTypeValue: '消息子类型',
    manualFlag: '是否手工标记已读',
    customConfiguration: '是否自定义配置',
    newMessageConfiguration: '新增消息配置',
    messageDetails: '待办消息明细'
  },
  loginLogs: {
    loginTime: '登录时间',
    loginName: '登陆名',
    userName: '姓名',
    IP: 'IP',
    usrCode: '用户代码',
    accountCode: '账号编码',
    companyName: '公司名称',
    officeName: '部门名称',
    roleName: '角色名称',
    browser: '浏览器',
    os: '操作系统',
    isSuccess: '是否成功登录',
    createTime: '登录时间',
    searchByIp: '可根据IP搜索',
    loginLogs: '登录日志',
    transferTodo: '待办转移',
    confirmTransferTodo: '确认转移',
    transfer: '转移',
    transferAll: '全部转移',
    transferOnlyOne: '请勾选一条人员信息进行待办转移操作',
    notSelf: '转办人与被转办人不能为同一个人',
    onlyOne: '仅能勾选一条信息查看登录日志',
    lessOne: '至少勾选一个',
    pickUser: '请选择用户'
  }
};